export const APP_BUILD_INFO = {
  "appName": "webapp-react",
  "deployVersion": "v0.1+51.911d1cf",
  "displayVersion": "v0.1+51",
  "builtAt": "2026-07-07T12:49:42.481Z",
  "buildNumber": "51",
  "commitSha": "911d1cf",
  "gitBranch": "master",
  "packageVersion": "0.1.0"
} as const
